module.exports = "img/photo8.9cd42e.jpg";